<template>
  <b-overlay :show="isLoading">
    <b-card>
      <h1 class="mb-2">لیست سوالات متداول</h1>
      <b-row>
        <b-col cols="12" md="6">
          <faq-category-picker
            @getCategory="setCategoryFilter"
          ></faq-category-picker>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="جستجوی سوال" label-for="searchCommand">
            <b-form-input
              id="searchCommand"
              placeholder="شرایط ثبت آگهی در فرادیدار"
              v-model="debouncedSearchVal"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="questionAnswersList"
            :fields="myTableColumns"
            responsive
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(createDate)="data">
              <div class="cursor-pointer d-flex flex-row">
                {{
                  new Date(data.item.createDate).toLocaleTimeString("fa-IR", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                }}
                -
                {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
              </div>
            </template>

            <template #cell(actions)="data">
              <router-link
                :to="{
                  name: 'apps-faq-edit',
                  params: {
                    id: data.item.id,
                  },
                }"
              >
                <feather-icon icon="EditIcon" size="20" class="text-primary" />
              </router-link>
              <button
                @click="renderDeleteModal(data.item)"
                type="button"
                class="btn btn-transparent"
              >
                <feather-icon icon="Trash2Icon" size="20" class="text-danger" />
              </button>
            </template>
          </b-table>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="pageNumber"
            :total-rows="totalCount"
            :per-page="count"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                style="transform: rotate(180deg)"
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <!-- Category Delete Modal Start -->
    <template v-if="tempFaqQuestion">
      <b-modal
        :title="`حذف دسته بندی ${tempFaqQuestion.questionText}`"
        id="modal-faq-question-delete"
        centered
        ok-title="حذف"
        cancel-title="بستن"
        @ok="sendFaqQuestionDeleteRequest(tempFaqQuestion.id)"
      >
        <p>
          آیا از حذف دسته بندی
          <strong>
            {{ tempFaqQuestion.questionText }}
          </strong>
          اطمینان دارید؟
        </p>
      </b-modal>
    </template>
    <!-- Category Delete Modal End -->
  </b-overlay>
</template>
<script>
export default {
  watch: {
    searchCommand: {
      handler(val) {
        this.getAllQuestionAnswers();
      },
    },
    categoryId: {
      handler(val) {
        this.getAllQuestionAnswers();
      },
    },
  },
  mounted() {
    this.getAllQuestionAnswers();
  },
  data() {
    return {
      isLoading: false,
      pageNumber: 1,
      count: 10,
      totalCount: null,
      questionAnswersList: null,
      searchCommand: null,
      categoryId: null,
      timeout: null,
      myTableColumns: [
        { key: "id", label: "شناسه" },
        { key: "questionText", label: "متن سوال" },
        { key: "catTitle", label: "دسته بندی" },
        { key: "createDate", label: "تاریخ ایجاد" },
        { key: "actions", label: "عملیات" },
      ],
      tempFaqQuestion: null,
    };
  },
  methods: {
    renderDeleteModal(faqQuestionObject) {
      this.tempFaqQuestion = faqQuestionObject;
      this.$nextTick(() => {
        this.$bvModal.show("modal-faq-question-delete");
      });
    },
    async sendFaqQuestionDeleteRequest(id) {
      try {
        this.isLoading = true;
        const _this = this;
        let deleteAFaqQuestionAnswer = new DeleteAFaqQuestionAnswer(_this);
        deleteAFaqQuestionAnswer.setParams({ id });
        await deleteAFaqQuestionAnswer.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "سوال با موفقیت حذف شد",
              },
            });
            this.$bvModal.hide("modal-faq-question-delete");
            _this.getAllQuestionAnswers();
          } else {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "خطا در حذف سوال",
                icon: "XIcon",
                variant: "danger",
                text: res.errorMessage,
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setCategoryFilter(catObject) {
      if (catObject && catObject.id) {
        this.categoryId = catObject.id;
      } else {
        this.categoryId = null;
      }
    },
    async getAllQuestionAnswers() {
      let reqParams = {
        pageNumber: this.pageNumber,
        count: this.count,
      };
      if (this.searchCommand) {
        reqParams["questionText"] = this.searchCommand;
      }
      if (this.categoryId) {
        reqParams["catId"] = this.categoryId;
      }
      try {
        this.isLoading = true;
        const _this = this;
        let getFaqQuestionAnswerList = new GetFaqQuestionAnswerList(_this);
        getFaqQuestionAnswerList.setParams(reqParams);
        await getFaqQuestionAnswerList.fetch((res) => {
          _this.totalCount = res.totalCount;
          _this.questionAnswersList = res.items;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    debouncedSearchVal: {
      get: function () {
        return this.searchCommand;
      },
      set: function (val) {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.searchCommand = val;
        }, 500);
      },
    },
  },
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BTabs,
    BTab,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    BPagination,
    BFormGroup,
    BForm,
    BModal,
    FaqCategoryPicker,
  },
};
import {
  GetFaqQuestionAnswerList,
  DeleteAFaqQuestionAnswer,
} from "@/libs/Api/FaqQuestionAnswer/FaqQuestionAnswer";
import FaqCategoryPicker from "@/@core/utils/FaqCategoryPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BTabs,
  BTab,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormTextarea,
  BPagination,
  BFormGroup,
  BForm,
  BModal,
} from "bootstrap-vue";
</script>
